import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Dropdown from "../../../components/Dropdown";
import PerformanceService from "../../../services/performance.service";
import Toaster from "../../../components/toaster";
import ScoreBarChart from "./ScoerBarChart";
import Loader from "../../../assets/images/icons/loader.gif";
import { getPeriodOptions } from "../../../periodOptions";

const Scores = () => {
  const createdAt = useSelector((state) => state.user.user?.createdAt);
  const [selectedOption, setSelectedOption] = useState("Select Game");
  const [selectedOption1, setSelectedOption1] = useState("This Year");
  const [selectedOption2, setSelectedOption2] = useState("score");
  const [selectedUser, setSelectedUser] = useState({
    label: "Select User",
    value: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [userData, setUserData] = useState([]);
  const [gameOptions, setGameOptions] = useState([]);
  const [data, setData] = useState([]);

  const convertToMinutes = (totalTimeInSeconds) =>
    `${Math.floor(totalTimeInSeconds / 60)}m ${totalTimeInSeconds % 60}s`;

  const handleUserSelect = (item) => {
    setSelectedUser(item);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option.label);
  };

  const handleOptionSelect1 = (option1) => {
    setSelectedOption1(option1.label);
  };

  const handleOptionSelect2 = (option2) => {
    setSelectedOption2(option2.value);
  };

  const options = gameOptions;

  const options1 = getPeriodOptions(createdAt);

  const options2 = [
    { label: "Total Score", value: "score" },
    { label: "Hits", value: "hits" },
    { label: "Accuracy", value: "passing" },
  ];

  const getScores = async () => {
    setIsLoading(true);
    try {
      if (
        selectedOption !== "Select Game" &&
        selectedOption1 !== "Select Period" &&
        selectedOption2 !== "Select Score" &&
        selectedUser.label !== "Select User"
      ) {
        const response = await PerformanceService.getScores(
          selectedOption !== "Select Game" ? selectedOption : "",
          selectedOption1 !== "Select Period" ? selectedOption1 : "",
          selectedUser.label !== "Select User" ? selectedUser.value : "",
          selectedOption2 !== "Select Score" ? selectedOption2 : ""
        );

        setData(response.data);
      }
    } catch (error) {
      Toaster("error", error.message);
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  /* const getScores = async () => {
    setIsLoading(true);

    try {
      const sessionData = JSON.parse(sessionStorage.getItem("isData"));

      const currentData = {
        selectedOption,
        selectedOption1,
        selectedUser: selectedUser?.value,
        selectedOption2,
      };

      const isDataChanged =
        !sessionData ||
        sessionData.selectedOption !== currentData.selectedOption ||
        sessionData.selectedOption1 !== currentData.selectedOption1 ||
        sessionData.selectedUser !== currentData.selectedUser ||
        sessionData.selectedOption2 !== currentData.selectedOption2;

      if (isDataChanged) {
        if (
          selectedOption !== "Select Game" &&
          selectedOption1 !== "Select Period" &&
          selectedOption2 !== "Select Score" &&
          selectedUser !== "Select User"
        ) {
          const response = await PerformanceService.getScores(
            selectedOption !== "Select Game" ? selectedOption : "",
            selectedOption1 !== "Select Period" ? selectedOption1 : "",
            selectedUser.label !== "Select User" ? selectedUser?.value : "",
            selectedOption2 !== "Select Score" ? selectedOption2 : ""
          );

          setData(response.data);
          if (response?.data) {
            sessionStorage.setItem("isData", JSON.stringify(currentData));
          }
        }
      }
    } catch (error) {
      Toaster("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };
 */
  useEffect(() => {
    getScores();
  }, [selectedOption, selectedOption1, selectedOption2, selectedUser]);

  const getPlayerByUser = async () => {
    setIsLoading(true);
    try {
      const [playerResponse, gameResponse] = await Promise.all([
        PerformanceService.getPlayerByUser(),
        PerformanceService.getGames(),
      ]);

      const playerData = [
        ...(playerResponse.data.data || []).map((item) => ({
          value: item.playerId,
          label: item.playername,
        })),
      ];

      const gameData = [
        ...(gameResponse.data.data || []).map((item) => ({
          value: item.gameName,
          label: item.gameName,
        })),
      ];

      setUserData(playerData);
      setGameOptions(gameData);
      setSelectedUser(playerData[0]);
      setSelectedOption(gameData[0]?.label || "Select Game");
      setSelectedOption1(options1[3]?.label);
      setSelectedOption2(options2[0]?.value);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPlayerByUser();
  }, []);

  return (
    <div>
      {isLoading ? (
        <div className="flex flex-col items-center justify-center mt-5">
          <img src={Loader} alt="Loader" className="w-16 h-16" />

          <div className="grid tab:flex items-center justify-center gap-4 mt-10">
            <Dropdown
              label={
                selectedUser.label ? selectedUser.label : selectedUser?.label
              }
              options={userData}
              onSelect={handleUserSelect}
            />
            <Dropdown
              label={selectedOption}
              options={options}
              onSelect={handleOptionSelect}
            />
            <Dropdown
              label={selectedOption1}
              options={options1}
              onSelect={handleOptionSelect1}
            />
            <Dropdown
              label={selectedOption2}
              options={options2}
              onSelect={handleOptionSelect2}
            />
          </div>
        </div>
      ) : (
        <>
          <div className="grid tab:grid-cols-3 w-full gap-4">
            {data != "" && (
              <div className="w-full tab:col-span-2 border p-4 rounded-lg h-fit">
                <ScoreBarChart
                  data={data}
                  label={selectedOption2}
                  selectedOption2={selectedOption2}
                />
                <div className="grid tab:flex items-center justify-center gap-4 mt-10">
                  <Dropdown
                    label={
                      selectedUser.label
                        ? selectedUser.label
                        : selectedUser?.label
                    }
                    options={userData}
                    onSelect={handleUserSelect}
                  />
                  <Dropdown
                    label={selectedOption}
                    options={options}
                    onSelect={handleOptionSelect}
                  />
                  <Dropdown
                    label={selectedOption1}
                    options={options1}
                    onSelect={handleOptionSelect1}
                  />
                  <Dropdown
                    label={selectedOption2}
                    options={options2}
                    onSelect={handleOptionSelect2}
                  />
                </div>
              </div>
            )}

            {data != "" && (
              <div className="max-lg:mt-5 tab:col-span-1">
                <div className="flex flex-col gap-4 text-white justify-center tab:justify-end w-full">
                  <div className="grid gap-3 p-4 rounded-lg border border-white/30 w-full">
                    <h4 className="text-xl">Total games</h4>
                    <h3 className="text-3xl font-semibold">
                      {data.TotalGamesPlayed ? data.TotalGamesPlayed : "--"}
                    </h3>
                  </div>
                  <div className="grid gap-3 p-4 rounded-lg border border-white/30 w-full">
                    <h4 className="text-xl">Total time played in minute</h4>
                    <h3 className="text-3xl font-semibold">
                      {data.TotalTime ? convertToMinutes(data.TotalTime) : "--"}
                    </h3>
                  </div>
                  <div className="grid gap-3 p-4 rounded-lg border border-white/30 w-full">
                    <h4 className="text-xl">Your best game and total score</h4>
                    <h3 className="text-3xl font-semibold">
                      {data?.userBest?.game} -{" "}
                      {data?.userBest?.score ? data?.userBest?.score : "--"}
                    </h3>
                  </div>
                  <div className="grid gap-3 p-4 rounded-lg border border-white/30 w-full">
                    <h4 className="text-xl">Total score progression in %</h4>
                    <h3 className="text-3xl font-semibold">
                      {data.TotalScoreProgression
                        ? data.TotalScoreProgression
                        : "--"}
                    </h3>
                  </div>
                </div>
              </div>
            )}
          </div>

          {data == "" && (
            <>
              <p className="flex justify-center text-white py-10 text-xl">
                Data Not Found
              </p>
              <div className="flex items-center justify-center gap-4 mt-12 flex-wrap">
                <Dropdown
                  label={selectedUser.label ? selectedUser.label : selectedUser?.label}
                  options={userData}
                  onSelect={handleUserSelect}
                />
                <Dropdown
                  label={selectedOption}
                  options={options}
                  onSelect={handleOptionSelect}
                />
                <Dropdown
                  label={selectedOption1}
                  options={options1}
                  onSelect={handleOptionSelect1}
                />
                <Dropdown
                  label={selectedOption2}
                  options={options2}
                  onSelect={handleOptionSelect2}
                />
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Scores;
